export default __webpack_public_path__ + "static/media/reddit.c08c824c.svg";